const timers = {

}

export function initTimer(name, callback, time){
	if(timers[name]){
		clearTimeout(timers[name]);
	}
	const timer = setTimeout(callback, time)
		timers[name] = timer;
	return timers[name];
}
export function getTimer(name){
	return timers[name];
}
export function removeTimer(name){
	clearTimeout(timers[name]);
}
